import { $post } from '@/api'
import Iconfont from '@/components/iconfont/iconfont'
import { usePopoverVisible } from '@/components/popover-confirm/usePopoverVisible'
import useBemClass from '@/utils/hooks/useBEMClass'
import { showLayer } from '@/utils/layer'
import $msg from '@/utils/message'
import { useRequest } from 'ahooks'
import { Popover } from 'antd'
import React from 'react'
import { useRef } from 'react'
import { goodsShelfStore } from '../../store/goods-shelf'
import { MallGoodsDetail } from '../goods-detail/goods-detail'
import classnames from 'classnames'

interface MallGoodsTableEditProps {
    goodId: number
    top: boolean
    showTop: boolean
}

const MallGoodsTableEdit: React.FC<MallGoodsTableEditProps> = props => {
    const cls = useBemClass('mall-table')

    const popoverAction = usePopoverVisible()
    const popoverRef = useRef<HTMLDivElement | null>(null)

    const goodTopReq = useRequest(
        () =>
            $post({
                url: '/mall/mallgoodsettop',
                params: {
                    mall_goods_id: props.goodId,
                    mall_group_id: goodsShelfStore.groupId,
                    mall_secondary_group_id: goodsShelfStore.secondGroupId || undefined,
                },
            }),
        {
            manual: true,
            onSuccess: () => {
                $msg('success', '更新成功')
                goodsShelfStore.setUpdateGroupStatus(!goodsShelfStore.updateGroupStatus)
            },
        },
    )

    return (
        <div
            className={classnames(cls('edit'), {
                [cls('edit-top')]: props.top,
            })}
            data-position-relative
        >
            <div
                className={cls('action')}
                onClick={() => {
                    showLayer(<MallGoodsDetail goodsId={props.goodId} onChange={() => {}} />)
                }}
            >
                编辑
            </div>
            {props.showTop && (
                <div ref={popoverRef}>
                    <Popover
                        {...popoverAction.options}
                        getPopupContainer={() => popoverRef.current as HTMLDivElement}
                        trigger="click"
                        placement="bottomRight"
                        content={
                            <div
                                className={`${cls('list-item')}`}
                                onClick={() => {
                                    if (goodTopReq.loading) return
                                    popoverAction.hidden()
                                    goodTopReq.run()
                                }}
                            >
                                {props.top ? '取消' : ''}置顶
                            </div>
                        }
                    >
                        <div className="more-icon">
                            <Iconfont name="iconmore2" size={20} />
                        </div>
                    </Popover>
                </div>
            )}
        </div>
    )
}

export default MallGoodsTableEdit
